"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  ORANGE: 'linear-gradient(90deg, rgba(191,91,149,1) 0%, rgba(244,174,69,1) 100%), rgb(191,91,149)',
  VIOLET: 'linear-gradient(160deg, rgba(139,53,201,0.9) 0%, rgba(175,115,218,0.70) 40%, rgba(255,255,255,0.2) 100%), #53B7C2',
  BLUE: 'linear-gradient(to bottom right, #7B50A0, #54B4C1)',
  LIGHT_BLUE: 'linear-gradient(150deg, rgba(139,53,201,1) 0%, rgba(255,255,255,0) 100%), #53B7C2',
  GREEN: 'linear-gradient(115deg, rgba(48,195,101,1) 0%, rgba(171,239,169,1) 100%), rgb(48,195,101)',
  LIGHT_GREEN: 'linear-gradient(to bottom right, #C5E1BE, #53B7C2)',
  GREY: 'linear-gradient(145.86deg, rgba(130, 130, 130, 0.6) 16%, rgba(30, 37, 38, 0.6) 85.85%);',
  H_BLACK: '#000',
  H_WHITE: '#fff',
  H_RED: '#F34161',
  H_YELLOW: '#fdbf33',
  H_LIGHT_ORANGE: '#F2C94C',
  H_FUCHSIA: '#B543B0',
  H_VIOLET: '#B543B0',
  H_LIGHT_BLUE: '#56CCF2',
  H_BLUE: '#2D9CDB',
  H_LIGHT_GREEN: '#BBE051',
  H_GREEN: '#6FCF97',
  H_DARK: '#333333',
  H_GREY: '#828282'
};
exports.default = _default;